import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import ProductLinking from "../../../components/SidebarMenuComponents/OAComponent/ProductLinking";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ProductLinkingPage() {
    const location = useLocation();

    return (
        <Page title="Product Linking Listing| tiketic" >
            
            <StickyHeader title="Product Linking Listing" />

            <ContentStyle>
                <ProductLinking/>
            </ContentStyle>
        </Page>
    );
}

